<template>
  <section class="final-selection">
    <p class="print-disclaimer">Disclaimer: This is a snapshot of the Tech Platform Assistant. Please note this tool is updated regularly; you can visit the live site for the most current information.</p>
    <div class="final-selection__head">
      <h2>Final Selection</h2>
      <a
        @click.prevent="goBackEvent"
        href="#"
        class="link--go-back"
      >
        Go Back
      </a>
    </div>

    <section class="final-selection__body">
      <div class="body__left">
        <div class="body__v-bar-content">
          <div class="body__content">
            <h2>Next Steps</h2>

            <template v-if="currentPlatform">
              <p
                v-if="currentPlatform.preferred"
                class="body__preferred-solution"
              >Preferred Solution</p>
            </template>

            <section
              v-html="nextStepsContent"
              @click.prevent="handleClick($event)"
            ></section>

            <template v-if="currentPlatform">
              <template v-if="currentPlatform.features">
                <blockquote
                  v-if="currentPlatform.features.propr_path"
                  class="propr-path"
                >
                  <h3>Propr</h3>
                  <div
                    @click.prevent="handleClick($event)"
                    v-html="currentPlatform.features.propr_path.notes"
                    class="propr-path__content"
                  ></div>
                </blockquote>
              </template>
            </template>

            <!-- <section v-if="this.currentPlatform === null ||
              this.currentPlatform.status === 'product_hosted'">
              no platform / product hosted
            </section> -->

            <div class="final-selection__session">
              <router-link :to="{ name: 'Home' }" @click.native="startOverEvent">
                <unum-button>
                  Start Over
                </unum-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="body__right">
        <div class="body__v-bar-content">
          <router-view v-if="!isProductHosted" />
          <form
            class="form-unknown-platform"
            v-if="isNullPlatform && !this.isFormSent"
            @submit.prevent="collectUnknownPlatform"
          >

            <p>
              We are constantly enhancing our connection portfolio and capabilities to meet the
              shifting needs of our customer. If you believe an integration with this partner would
              be advantageous, please provide the following information:
            </p>

            <br>

            <unum-textbox
              label="Platform Name"
              :placeholder="'Enter Platform'"
              name="unknown-platform__name"
              v-model="unknownPlatform.platformName"
              v-validate="'required'"
              data-vv-value-path="unknown-platform__name"
              :errorBag="errors"
            />

            <div
              :class="[
                'unum-field-checkbox',
                { 'has-error': errors ?
                  errors.has('unknown-platform__offered-products--individual') ||
                  errors.has('unknown-platform__offered-products--group') : false }
              ]"
            >
              <p>
                Will you be offering individual and/or group products?
                <span class="text-help">(Select all that apply)</span>
              </p>
              <div class="form-unknown-platform__flex">
                <checkbox
                  name="unknown-platform__offered-products--individual"
                  value="individual"
                  v-model="unknownPlatform.offeredProducts"
                  v-validate="!isOneSelected_offeredProducts ? 'required' : false"
                  data-vv-value-path="unknown-platform__offered-products--individual"
                  data-vv-validate-on="none"
                >
                  Individual
                </checkbox>

                <checkbox
                  name="unknown-platform__offered-products--group"
                  value="group"
                  v-model="unknownPlatform.offeredProducts"
                  v-validate="!isOneSelected_offeredProducts ? 'required' : false"
                  data-vv-value-path="unknown-platform__offered-products--group"
                  data-vv-validate-on="none"
                >
                  Group
                </checkbox>
              </div>
            </div>

            <div
              :class="[
                'unum-field-datepicker',
                { 'has-error': errors ?
                  errors.has('unknown-platform__planned-enrollment-date') : false }
              ]"
            >
              <p>What is your planned enrollment date?</p>

              <unum-textbox
                type="date"
                name="unknown-platform__planned-enrollment-date"
                :placeholder="'Planned Enrollment Date'"
                v-model="unknownPlatform.plannedEnrollmentDate"
                v-validate="'required'"
                data-vv-value-path="unknown-platform__planned-enrollment-date"
              />
              <!-- <datepicker
                name="unknown-platform__planned-enrollment-date"
                v-model="unknownPlatform.plannedEnrollmentDate"
                v-validate="'required'"
                data-vv-value-path="unknown-platform__planned-enrollment-date"
                :inline="true"
              /> -->
            </div>

            <unum-button>Submit</unum-button>
          </form>

          <div
            class="form-sent-message"
            v-if="this.isFormSent"
          >
            <h3>Thanks for helping us serve our customers better.</h3>
            <router-link :to="{ name: 'Wizard' }" @click.native="unknownPlatformWizardButtonEvent">
              Are you interested in other platforms that are available for your case?
            </router-link>
          </div>
          <div
            class="form-sent-message"
            v-if="isProductHosted"
          >
            <h3>
              We can help you find integrated platforms that are compatible with your enrollment
              platform requirements.
            </h3>
            <router-link :to="{ name: 'Wizard' }" @click.native="productHostedWizardButtonEvent">
              Help me Choose Another Platform
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import Firebase from 'firebase'
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { Checkbox, Radio } from 'vue-checkbox-radio'

import UnumButton from '@/components/ui/Button'
import UnumTextbox from '@/components/ui/Textbox'

import { db, platformNotFoundAPI } from '@/appConfig/appConfig'

import sessionEvent from '@/util/sessionEvent'

export default {
  created () {
    if (this.selectedPlatform) {
      this.setCurrentPlatform(this.selectedPlatform)
    }
  },
  mounted () {
    let unknownPlatformName = this.$route.query.unknownPlatform

    if (unknownPlatformName) {
      this.unknownPlatform = {
        session: { ...this.session },
        platformName: this.$route.query.unknownPlatform,
        offeredProducts: [],
        plannedEnrollmentDate: null
      }
    } else {
      this.unknownPlatform = {
        session: { ...this.session },
        platformName: null,
        offeredProducts: [],
        plannedEnrollmentDate: null
      }
    }
    console.log(this.currentPlatform)
  },
  name: 'UnumFinalSelection',
  data () {
    return {
      isFormSent: false,
      unknownPlatform: {
        platformName: null,
        offeredProducts: [],
        plannedEnrollmentDate: null,

        brokerName: null,
        caseName: null,
        caseSize: null,
        caseState: null,
        producerName: null,
        producerNumber: null
      },
      not_integrated_platforms: [],
      default_next_steps_content_fully_integrated: null,
      default_next_steps_content_product_hosted: null,
      default_next_steps_content_future_integration: null,
      default_next_steps_content_not_found: null
    }
  },
  components: {
    Datepicker,
    Checkbox,
    Radio,
    UnumButton,
    UnumTextbox
  },
  methods: {
    ...mapActions('platforms', [
      'clearPlatformSelection',
      'clearCurrentPlatform',
      'clearChosenPlatforms',
      'setCurrentPlatform'
    ]),
    ...mapActions('wizard', [
      'clearWizardAnswers'
    ]),
    ...mapActions('user', [
      'clearSession'
    ]),
    askFullyClearSession () {
      this.$modal.show('dialog', {
        title: 'Caution',
        text: `Do you want to start over with your <strong>current case</strong> information or <strong>new case</strong> information?`,
        width: 700,
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Current Case',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'New Case',
            handler: () => {
              this.fullyClearSession()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    fullyClearSession () {
      this.clearWizardAnswers()
      this.clearCurrentPlatform()
      this.clearChosenPlatforms()
      this.clearSession()
    },
    collectUnknownPlatform () {
      console.count('CHECKING VALIDATION')
      this.$validator.validateAll()
        .then(isValid => {
          if (isValid) {
            var that = this
            console.count('VALID!!!')
            const sessionKey = this.$storage.get('session_key')
            sessionEvent(sessionKey, 'submit_unknown_platform_form', {
              platform: this.unknownPlatform.platformName,
              products: this.unknownPlatform.offeredProducts,
              enrollment_date: this.unknownPlatform.plannedEnrollmentDate
            })
            this.$firebaseRefs.not_integrated_platforms.push(this.unknownPlatform)
            this.isFormSent = true
            const monthNumber = parseInt(this.unknownPlatform.plannedEnrollmentDate.split('-')[1], 10)
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December']
            const month = monthNames[monthNumber]
            const day = parseInt(this.unknownPlatform.plannedEnrollmentDate.split('-')[2], 10)
            const date = `${month} ${day}, ${this.unknownPlatform.plannedEnrollmentDate.split('-')[0]}`
            let products = JSON.parse(JSON.stringify(that.unknownPlatform.offeredProducts))
            let productsCapitalized = []
            products.forEach((p) => {
              productsCapitalized.push(p.charAt(0).toUpperCase() + p.slice(1))
            })
            Firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
              const data = {
                PlatformName: that.unknownPlatform.platformName,
                OfferedProducts: productsCapitalized,
                PlannedEnrollmentDate: date,
                Token: idToken
              }
              axios.post(platformNotFoundAPI, data)
                .then(function (res) {
                  that.$notify({
                    type: 'success',
                    group: 'site_notifications',
                    title: 'Success',
                    text: 'Platform has been added to database'
                  })
                })
                .catch(function (err) {
                  console.log(err)
                  that.$notify({
                    type: 'error',
                    group: 'site_notifications',
                    title: 'Error',
                    text: 'Error sending platform information.'
                  })
                })
            }).catch(function (error) {
              console.log(error)
            })
          } else {
            this.$notify({
              type: 'error',
              group: 'site_notifications',
              title: 'Error',
              text: 'Please complete the form. All fields are required.'
            })
          }
        })
    },
    goBackEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_back_link', {
        to: this.$store.state.route.from.fullPath
      })
      this.$router.go(-1)
    },
    startOverEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_final_selection_start_over_button')
    },
    unknownPlatformWizardButtonEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_unknown_platform_wizard_button')
    },
    productHostedWizardButtonEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_product_hosted_wizard_button')
    },
    handleClick (e) {
      if (Element.prototype.msMatchesSelector) {
        if (e.target.msMatchesSelector('a')) {
          window.open(e.target.getAttribute('href'))
        }
      } else {
        if (e.target.matches('a')) {
          window.open(e.target.getAttribute('href'))
        }
      }
    }
  },
  computed: {
    ...mapState('platforms', [
      'selectedPlatform',
      'currentPlatform'
    ]),
    ...mapState('user', [
      'session'
    ]),
    isOneSelected_offeredProducts () {
      return !!this.unknownPlatform.offeredProducts.length > 0
    },
    isFullyIntegrated () {
      if (this.currentPlatform) {
        return this.currentPlatform.status === 'fully_integrated'
      }
      return false
    },
    isProductHosted () {
      if (this.currentPlatform) {
        return this.currentPlatform.status === 'product_hosted'
      }
      return false
    },
    isFutureIntegration () {
      if (this.currentPlatform) {
        return this.currentPlatform.status === 'future_integration'
      }
      return false
    },
    isCaseSizeAtLeast500 () {
      return this.session.caseSize >= 500
    },
    isNullPlatform () {
      return this.currentPlatform === null
    },
    nextStepsContent () {
      if (this.currentPlatform) {
        let content = ''
        if (this.currentPlatform.nextStepsContent) {
          content = this.currentPlatform.nextStepsContent.replace(/\[platform-name\]/g, this.currentPlatform.displayName)
          return content
        }
        switch (this.currentPlatform.status) {
          case 'fully_integrated':
            if (this.default_next_steps_content_fully_integrated) {
              content = this.default_next_steps_content_fully_integrated['.value'].replace(/\[platform-name\]/g, this.currentPlatform.displayName)
            }
            return content
          case 'product_hosted':
            if (this.default_next_steps_content_product_hosted) {
              content = this.default_next_steps_content_product_hosted['.value'].replace(/\[platform-name\]/g, this.currentPlatform.displayName)
            }
            return content
          case 'future_integration':
            if (this.default_next_steps_content_future_integration) {
              content = this.default_next_steps_content_future_integration['.value'].replace(/\[platform-name\]/g, this.currentPlatform.displayName)
            }
            return content
          default:
            return '<p>null status</p>'
        }
      }
      return this.default_next_steps_content_not_found ? this.default_next_steps_content_not_found['.value'] : ''
    }
  },
  firebase () {
    return {
      not_integrated_platforms: db.ref('not_integrated_platforms'),
      default_next_steps_content_fully_integrated: db.ref('settings').child('default_next_steps_content_fully_integrated'),
      default_next_steps_content_product_hosted: db.ref('settings').child('default_next_steps_content_product_hosted'),
      default_next_steps_content_future_integration: db.ref('settings').child('default_next_steps_content_future_integration'),
      default_next_steps_content_not_found: db.ref('settings').child('default_next_steps_content_not_found')
      // default_next_steps_content_fully_integrated: {
      //   source: db.ref('settings').child('default_next_steps_content_fully_integrated'),
      //   asObject: true
      // },
      // default_next_steps_content_product_hosted: {
      //   source: db.ref('settings').child('default_next_steps_content_product_hosted'),
      //   asObject: true
      // },
      // default_next_steps_content_future_integration: {
      //   source: db.ref('settings').child('default_next_steps_content_future_integration'),
      //   asObject: true
      // }
    }
  }
  // beforeRouteLeave: function (to, from, next) {
  //   if (to.name === 'Compare') {
  //     console.log(from)

  //     this.$modal.show('dialog', {
  //       title: 'Caution',
  //       text: `By navigating away, you will lose any selections or results so far.`,
  //       buttons: [
  //         {
  //           title: 'Cancel',
  //           handler: () => {
  //             this.$modal.hide('dialog')
  //           }
  //         },
  //         {
  //           title: 'Ok',
  //           handler: () => {
  //             this.clearWizardAnswers()
  //             this.clearCurrentPlatform()
  //             this.clearChosenPlatforms()
  //             this.$modal.hide('dialog')
  //             next()
  //           }
  //         }
  //       ]
  //     })
  //   } else {
  //     next()
  //   }
  // }
  // beforeDestroy () {
  //   this.clearSelectedPlatform()
  // },
  // beforeRouteEnter (to, from, next) {
  //   console.log(this)
  //   next(vm => {
  //     if (vm.$root.$store.getters['platforms/selectedPlatform'] === null) {
  //       vm.$root.$router.go(-1)
  //       vm.$root.$notify({
  //         type: 'error',
  //         group: 'site_notifications',
  //         title: 'Error',
  //         text: 'No Selected Platform'
  //       })
  //     }
  //   })
  // }
}
</script>

<style lang="scss">
.iphone-safari {
  .final-selection {
    &__body {
      height: calc(100vh - 228px);
    }
  }
}

.final-selection {
  background: $lightBlue;

  @media print {
    overflow: visible;
    position: static !important;
    width: 100%;
    height: auto;
  }

  .media {
    @media print {
      display: none;
    }
  }

  &__head {
    height: 4.688rem;
    background: $lightBlue;
    padding: .75rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: left;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;
    flex-flow: column nowrap;

    @include bp($small) {
      padding: .75rem 3rem;
    }

    @media print {
      height: auto;
      padding: 0.75rem 1.5rem;
    }

    h2 {
      color: $blue;
      font-weight: 600;
      margin: 0;
      order: 1;
    }
  }

  &__body {
    display: flex;
    background: #fff;
    padding: 0; // 0 0 0 3rem;
    overflow: hidden;
    height: 100%;
    @media print {
      overflow: visible;
      display: block;
      height: auto;
    }
  }

  .body {
    &__content {
      padding: 2rem 2rem 1rem;
      @include bp($medium) {
        padding: 3rem;
      }
      h2 {
        margin-top: 0;
      }
      ul {
        line-height: 1.4;
      }
      blockquote {
        margin: 0 0 20px;
        font-weight: 600;
        background: #FFF7E1;
        padding: 1rem 2rem;
        & > *:first-child {
          margin-top: 0;
        }
        & > *:last-child {
          margin-bottom: 0;
        }
        &.propr-path {
          margin: 20px 0 0;
        }
      }
      figure {
        margin: 1rem 0;
      }
    }
    &__left {
      width: 50%;
      border-right: .063rem solid $lightGrey;
      @media print {
        width: 100%;
        border-right: 0;
        border-bottom: 1px solid $lightGrey;
      }
    }
    &__right {
      width: calc(50% - .063rem);
      background: #fff;
      position: relative;
      @media print {
        width: 100%;
      }
    }

    &__left,
    &__right {
      // padding-top: 1.5rem;
      height: calc(100vh - 152px);
      overflow: auto;
      @include bp($medium) {
        height: calc(100vh - 155px);
      }
      @media print {
        overflow: visible;
        height: auto;
      }
    }
    &__preferred-solution {
      position: relative;
      display: inline-block;
      margin: 0;
      padding: 0.5rem 1rem 0.5rem 3rem;
      color: $preferred-textColor;
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
      font-size: 0.75rem;
      background: $preferred-bgColor;
      &:before {
        content: '';
        left: 1rem;
        width: 1rem;
        height: 1rem;
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('~@/assets/images/ui/icon-star.svg');
      }
    }
  }

  &__session {
    margin-top: 2rem;
    border-top: .063rem solid $lightGrey;
    padding-top: 2rem;
    text-align: center;
    @media print {
      display: none;
    }
  }

  .vdp-datepicker__calendar {
    width: 100%;
  }
  .icon--info {
    @media print {
      display: none;
    }
  }
  .feature-note {
    @media print {
      display: block;
      font-weight: normal !important;
      font-size: rem(10px) !important;
      line-height: 1.2 !important;
    }
  }
}

.propr-path__content {
  & > *:last-child {
    margin-bottom: 0;
  }
}

.form-unknown-platform {
  padding: 2rem;
  @include bp($medium) {
    padding: 3rem;
  }
  @media print {
    display: none;
  }

  &__flex {
    margin: 0 auto 2rem;

    @include bp($small) {
      display: flex;
    }

    .checkbox-component {
      margin: 0 0 1rem 0;
      @include bp($small) {
        margin: 0;
      }
      & + .checkbox-component {
        @include bp($small) {
          margin: 0 0 0 4rem;
        }
      }
    }
  }

  .unum-field-datepicker {
    margin-bottom: 2rem;
  }
}

.form-sent-message {
  padding: 0 2rem 2rem;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  @include bp($medium) {
    padding: 3rem 7rem;
  }

  h3 {
    color: #757575;
    font-size: 1.125rem;
  }
}

.unum-field-checkbox,
.unum-field-datepicker {
  &.has-error {
    color: $red;
  }
}

// override platform-viewer styles
.final-selection {
  @include bp('767px', 'max-width') {
    &__body {
      display: block;
      overflow: auto;
      height: calc(100vh - 8rem - 4.688rem);
      @media print {
        height: auto;
      }
    }

    .body {
      &__left,
      &__right {
        border: 0;
        height: auto;
        width: 100%;
        overflow: initial;
        @media print {
          overflow: visible;
        }
      }
    }

    .platform-viewer {
      &__head {
        position: relative;
      }

      .feature-sections--final-selection {
        height: auto;
        overflow: auto;
        @media print {
          overflow: visible;
        }
      }

      .feature-section {
        width: 100%;

        .table-wrapper {
          &:before {
            content: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FinalSelection.vue